import { connect, useSelector } from 'react-redux';
import { DashboardToggle, Avatar } from 'components';
import styles from '../dashboard.module.css';

function DashboardUser({ isSm, isMd }) {
	const user = useSelector((state) => state.user.user);
	const child = useSelector((state) => state.lifebooks.child);
	const isCaseManager = user.type === 'case-manager';
	const childName = [child?.firstname, child?.lastname].filter(Boolean).join(' ');
	const displayName = isCaseManager
		? 'Family Connections'
		: [user.firstname, user.lastname].filter(Boolean).join(' ');

	return (
		<div className={styles.dashboardUserRoot}>
			{isSm || isMd ? (
				<DashboardToggle className={styles.dashboardToggle} />
			) : null}
			{!isCaseManager ? (
				<Avatar identity={user} alt={displayName} image={user.photo?.url} />
			) : null}
			{displayName ? (
				<div className={styles.dashboardUserContainer}>
					<div className={styles.dashboardUserName}>{displayName}</div>
					{isCaseManager && childName ? (
						<div className={styles.dashboardUserContext}>{childName}</div>
					) : null}
				</div>
			) : null}
		</div>
	);
}

const mapStateToProps = ({ mediaQuery: { isSm, isMd } }) => {
	return { isSm, isMd };
};
export default connect(mapStateToProps)(DashboardUser);
